module.exports = __webpack_public_path__ + "img/icon_footer_fifa_selected.db6b725b.png";